import * as React from 'react'

import './loader.scss'

export enum SpinnerType {
  DEFAULT,
  INLINE,
}

export class Spinner extends React.Component<{ message?: string | JSX.Element; type?: SpinnerType }, any> {
  public render() {
    const cls = 'css-loader'
    const typeCls = this.props.type && this.props.type === SpinnerType.INLINE ? ' react-spinner__inline' : ''
    const msg = this.props.message ? <div className="message">{this.props.message}</div> : ''
    return (
      <div className={'react-spinner' + typeCls}>
        <div className={cls} />
        {msg}
      </div>
    )
  }
}
